// extracted by mini-css-extract-plugin
export default {"wrapper":"ModalAddProductItem_wrapper__WpQDG","head":"ModalAddProductItem_head__s19Pf","content":"ModalAddProductItem_content__L79fQ"};